import parseHomePageUrlToConfig from '../../utils/cars-utils/parse-home-page';
import parseReviewPageUrlToConfig, { parseCarsReviewUrl } from "../../utils/cars-utils/parse-review-page-url-to-config";
import parseResultsPageUrlToConfig from "../../utils/cars-utils/parse-results-page-url-to-config";
import parseHobUrlToConfig from '../../utils/cars-utils/parse-hob-url-to-config';
import { 
  parseSeoParamsToConfig, 
  parseHCBFlag, 
  parseCacheConfig, 
  getCacheDate, 
  parseFlowName 
} from "../../utils/cars-utils/parse-seo-params-to-config";
import { setVerticalFooterData } from "../../core-components/Footer/footer-data";
import { getMetaData, setMetaData } from '../../utils/seo-meta-data';
import { aerospikeConfig } from "../shared/config/infraConfig";
import {
  fetchSeoRouteData,
  fetchSeoCityData,
  fetchSeoAirportCityData,
  fetchSeoAirportRouteData,
  fetchSeoCarSpecificRouteData,
  fetchSeoRydeRouteData,
  fetchSeoRentalData,
  fetchOneWayCabInterlinkingData,
  fetchSeoCarSpecificCityData,
  getPageLoadHOBData,
  fetchCabConfigData,
  fetchCharDhamRouteData
} from "../shared/pages/SeoPage/redux/thunks";
import HomePage from '../shared/pages/Homepage/HomePage';
import SearchPage from '../shared/pages/SearchPage/Searchpage';
import ReviewPage from '../shared/pages/ReviewPage/Reviewpage';
import FaqPage from '../shared/pages/FaqPage/FaqPage';
import RoutePage from '../shared/pages/SeoPage/RoutePage';
import CityPage from '../shared/pages/SeoPage/CityPage';
import AirportPage from '../shared/pages/SeoPage/AirportPage';
import RentalPage from '../shared/pages/SeoPage/RentalPage';
import HobLandingPage from '../shared/pages/HouseOfBrands/HobLanding/HobLandingPage';
import HobListingPage from '../shared/pages/HouseOfBrands/HobListing/HobListingPage';
import HobThankYouPage from '../shared/pages/HouseOfBrands/HobThankYou/HobThankYouPage';
import { fetchPageMakerAPIServer } from '../shared/common/redux/thunks';
import { 
  HOURLY_RENTALS_DETAILS, 
  ONEWAY_INTERLINKING_DATA, 
  SET_ONEWAY_CAB, 
  UPDATE_HR_PACKAGE, 
  UPDATE_HR_PACKAGE_TIME, 
  UPDATE_MULTICITY_STOPOVERS, 
  UPDATE_PREVIOUS_MULTICITY_STOPOVERS 
} from '../shared/pages/SearchPage/redux/action-types';
import { 
  BLANK_VALUE, 
  CABS, 
  CACHE_KEY, 
  HR, 
  INBOUND_CONTACT_NUMBER, 
  PROVISIONAL_HOB_REQUEST_TYPE, 
  rental, 
  RENTAL_PAGE, 
  SEO_FORM_COUPON_DATA, 
  SHOW_INBOUND_CALL, 
  SHOW_SEO_LEADGEN, 
  SHOW_SEO_LEAVE_INTENT, 
  UPDATE_QUERY_FIELDS_DATA, 
  UPDATE_RECENT_SEARCH, 
  UPDATE_SEO_FLOW, 
  WAY_TYPE_IN, SET_FLOW 
} from '../shared/config/constants';
import { 
  SEO_PAGE_NAME, 
  UPDATE_CAR_TYPE, 
  UPDATE_CITY_PAGE_DATA, 
  UPDATE_PAGE_TYPE, 
  UPDATE_ROUTE_PAGE_DATA, 
  UPDATE_SELECTED_CAB, 
  UPDATE_SRC_FROM_PARAMS 
} from '../shared/pages/SeoPage/redux/seo-action-types';
import { 
  LOCAL_RENTAL, 
  seoAirportCityPageName, 
  seoAirportRoutePageName, 
  seoCharDhamPageName, 
  seoCityCarTypeName, 
  seoCityPageName, 
  seoRentalPageName, 
  seoRouteCarTypeName, 
  seoRoutePageName, 
  seoRouteRydePageName 
} from '../shared/utils/util-constants';
import { 
  UPDATE_CABS_CONFIG_DATA, 
  UPDATE_CAB_FAQ_DATA, 
  UPDATE_UNIFICATION_FLOW, 
  UPDATE_DESTINATION, 
  UPDATE_SOURCE 
} from '../shared/common/redux/action-types';
import { 
  UPDATE_HOB_LANDING_PARAMS, 
  UPDATE_HOB_LANDING_RESPONSE, 
  UPDATE_HOB_LISTING_PARAMS, 
  UPDATE_HOB_THANKYOU_PARAMS 
} from '../shared/pages/HouseOfBrands/redux/action-types';
import CharDhamPage from '../shared/pages/SeoPage/CharDham/CharDhamPage';
import { createUnificationRedirectLandingUrl, createUnificationRedirectUrl } from 'dweb-cars/shared/utils/redirect-utils';
import logger from '../../utils/logger';


// const HomePage = loadable(() => import(/* webpackPrefetch: true */ '../shared/pages/Homepage/HomePage'));
// const SearchPage = loadable(() => import(/* webpackPrefetch: true */ '../shared/pages/SearchPage/Searchpage'));
// const ReviewPage = loadable(() => import(/* webpackPrefetch: true */ '../shared/pages/ReviewPage/Reviewpage'));

const GoibiboRoutes = [
  {
    path: ["/cars/:airportParams-ac-cabs/", "/cars/:airportParams-ac/"],
    component: RoutePage,
    key: "AirportRoutePage",
    toBeSSRed: true,
    fillStoreWaitTime: 7000,
    showHeader: true,
    showFooter: true,
    toBeCached: true,
    stickyHeader: true,
    populateStoreFromUrl: ({ params, searchString, baseUrl }, dispatch) => {
      const hardReloadFlag = parseHCBFlag(searchString);
      const cacheFor = parseCacheConfig(searchString);
      const flow = parseFlowName(searchString);
      dispatch({
        type: SEO_PAGE_NAME,
        seoPageName: seoAirportRoutePageName
      });
      dispatch({
        type: "UPDATE_AIRPORT_FROM_PARAMS",
        data: { airportParams: `${params?.airportParams}-ac`, hardReloadFlag, cacheFor, airportType: 'ac' },
      });
      dispatch({
        type: UPDATE_SEO_FLOW,
        isSeo: true
      });
      dispatch({
        type: SET_FLOW,
        flow: flow || "seo",
      });
    },
    fillStoreOnServer: async ({ state, localData, cookieString }) => {
      const { seoPage = {} } = state;
      const { airportParams, hardReloadFlag, cacheFor } = seoPage;
      const data = await fetchSeoAirportRouteData(airportParams, hardReloadFlag);
      const actions = [];
      actions.push({
        type: UPDATE_UNIFICATION_FLOW,
        isUnificationFlow: 1
      });
      if (data) {
        actions?.push({
          type: UPDATE_ROUTE_PAGE_DATA,
          results: data?.lob_data?.results,
          hideLob: data?.lob_data?.hideLob,
          voy_data: data?.voy_data,
          seo_meta: data?.seo_meta,
          top_routes_from_src: data?.routes?.top_routes_from_src,
          top_routes_from_src_title: data?.routes?.top_routes_from_src_title,
          top_routes_to_dest: data?.routes?.top_routes_to_dest,
          top_routes_to_dest_title: data?.routes?.top_routes_to_dest_title,
          rental_data: data?.routes?.rental_data,
          faq: data?.template?.faq,
          benefits: data?.template?.benefits,
          lpg: data?.template?.lpg,
          place_information: data?.template?.place_information,
          seo_content: data?.template?.seo_content,
          interlinking: data?.interlinking,
          dynamic_footer_data: data?.dynamic_footer_data,
          aggregate_ratings : data?.aggregate_ratings,
          schema_min_fare: data?.schema_min_fare,
          seo_multi_city: data?.seo_multi_city
        });
        actions.push({
          type: SHOW_SEO_LEADGEN,
          showSEOLeadgen: data?.showSEOLeadgen
        });
        actions.push({
          type: SHOW_INBOUND_CALL,
          showInboundCall: data?.showInboundCall
        })
        actions.push({
          type: INBOUND_CONTACT_NUMBER,
          contactNumber:data?.contactNumber
        })
        if (data?.showSEOLeadgen && data?.query_fields && data?.query_fields?.length > 0) {
          actions.push({
            type: UPDATE_QUERY_FIELDS_DATA,
            queryFields: data.query_fields,
          });
        }
        if (data?.common_data?.source && data?.common_data?.destination) {
          const parseData = parseSeoParamsToConfig({
            source: data?.common_data?.source,
            destination: data?.common_data?.destination,
            tripType: "ONE_WAY",
            rf: "ow",
            cacheFor
          });
          actions.push({
            type: "UPDATE_RECENT_SEARCH",
            data: parseData,
          });
        }
        actions.push({
          type: SHOW_SEO_LEAVE_INTENT,
          showSEOLeaveIntent: data?.showSEOLeaveIntentForm
        })
        actions.push({
          type: SEO_FORM_COUPON_DATA,
          seoFormCouponData: data?.couponData
        })
      }

      return actions;
    },
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        const cacheFor = parseCacheConfig(searchString);
        const ttl = (cacheFor + 2)*86400; // Adding 2 -> Increase cache duration to 2 days for all pages
        const date = getCacheDate(cacheFor);
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        return { 
          cacheKey: `cabs_dweb_airport_route_${params.airportParams}-ac_${year}-${+month + 1}-${day}`,
          dynamicTTL: ttl
        };
      },
      aerospikeConfig: { ...aerospikeConfig },
    },
  },
  {
    path: ["/cars/:airportParams-ca-cabs/", "/cars/:airportParams-ca/"],
    component: RoutePage,
    key: "AirportRoutePage",
    toBeSSRed: true,
    fillStoreWaitTime: 7000,
    showHeader: true,
    showFooter: true,
    toBeCached: true,
    stickyHeader: true,
    populateStoreFromUrl: ({ params, searchString, baseUrl }, dispatch) => {
      const hardReloadFlag = parseHCBFlag(searchString);
      const cacheFor = parseCacheConfig(searchString);
      const flow = parseFlowName(searchString);
      dispatch({
        type: SEO_PAGE_NAME,
        seoPageName: seoAirportRoutePageName
      });
      dispatch({
        type: "UPDATE_AIRPORT_FROM_PARAMS",
        data: { airportParams: `${params?.airportParams}-ca`, hardReloadFlag, cacheFor, airportType: 'ca' },
      });
      dispatch({
        type: UPDATE_SEO_FLOW,
        isSeo: true
      });
      dispatch({
        type: SET_FLOW,
        flow: flow  || "seo",
      });
    },
    fillStoreOnServer: async ({ state, localData, cookieString }) => {
      const { seoPage = {} } = state;
      const { airportParams, hardReloadFlag, cacheFor } = seoPage;
      const data = await fetchSeoAirportRouteData(airportParams, hardReloadFlag);
      const actions = [{
        type: UPDATE_UNIFICATION_FLOW,
        isUnificationFlow: 1
      }];
      if (data) {
        actions?.push({
          type: UPDATE_ROUTE_PAGE_DATA,
          results: data?.lob_data?.results,
          hideLob: data?.lob_data?.hideLob,
          voy_data: data?.voy_data,
          seo_meta: data?.seo_meta,
          top_routes_from_src: data?.routes?.top_routes_from_src,
          top_routes_from_src_title: data?.routes?.top_routes_from_src_title,
          top_routes_to_dest: data?.routes?.top_routes_to_dest,
          top_routes_to_dest_title: data?.routes?.top_routes_to_dest_title,
          rental_data: data?.routes?.rental_data,
          faq: data?.template?.faq,
          benefits: data?.template?.benefits,
          lpg: data?.template?.lpg,
          place_information: data?.template?.place_information,
          seo_content: data?.template?.seo_content,
          interlinking: data?.interlinking,
          dynamic_footer_data: data?.dynamic_footer_data,
          aggregate_ratings : data?.aggregate_ratings,
          schema_min_fare: data?.schema_min_fare,
          seo_multi_city: data?.seo_multi_city
        });
        actions.push({
          type: SHOW_SEO_LEADGEN,
          showSEOLeadgen: data?.showSEOLeadgen
        });
        actions.push({
          type: SHOW_INBOUND_CALL,
          showInboundCall: data?.showInboundCall         
        })
        actions.push({
          type: INBOUND_CONTACT_NUMBER,
          contactNumber:data?.contactNumber
        })
        if (data?.showSEOLeadgen && data?.query_fields && data?.query_fields?.length > 0) {
          actions.push({
            type: UPDATE_QUERY_FIELDS_DATA,
            queryFields: data.query_fields,
          });
        }
        if (data?.common_data?.source && data?.common_data?.destination) {
          const parseData = parseSeoParamsToConfig({
            source: data?.common_data?.source,
            destination: data?.common_data?.destination,
            tripType: "ONE_WAY",
            rf: "ow",
            cacheFor
          });
          actions.push({
            type: "UPDATE_RECENT_SEARCH",
            data: parseData,
          });
        }
        actions.push({
          type: SHOW_SEO_LEAVE_INTENT,
          showSEOLeaveIntent: data?.showSEOLeaveIntentForm
        })
        actions.push({
          type: SEO_FORM_COUPON_DATA,
          seoFormCouponData: data?.couponData
        })
      }

      return actions;
    },
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        const cacheFor = parseCacheConfig(searchString);
        const ttl = (cacheFor + 2)*86400; // Adding 2 -> Increase cache duration to 2 days for all pages
        const date = getCacheDate(cacheFor);
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        return { 
          cacheKey: `cabs_dweb_airport_route_${params.airportParams}-ca_${year}-${+month + 1}-${day}`,
          dynamicTTL: ttl
        };
      },
      aerospikeConfig: { ...aerospikeConfig },
    },
  },
  {
    path: "/cars/:carType-car-from-:src-to-:dest/",
    component: RoutePage,
    key: "CarSpecificRoutePage",
    toBeSSRed: true,
    fillStoreWaitTime: 7000,
    showHeader: true,
    showFooter: true,
    toBeCached: true,
    stickyHeader: true,
    populateStoreFromUrl: ({ params, searchString, baseUrl }, dispatch) => {
      const hardReloadFlag = parseHCBFlag(searchString);
      const cacheFor = parseCacheConfig(searchString);
      const flow = parseFlowName(searchString);
      dispatch({
        type: SEO_PAGE_NAME,
        seoPageName: seoRouteCarTypeName,
      });
      dispatch({
        type: "UPDATE_SRC_DEST_FROM_PARAMS",
        data: { src: params?.src, dest: params?.dest, hardReloadFlag, cacheFor, carType: params?.carType },
      });
      dispatch({
        type: UPDATE_SEO_FLOW,
        isSeo: true
      });
      dispatch({
        type: SET_FLOW,
        flow: flow  || "seo",
      });
    },
    fillStoreOnServer: async ({ state, localData, cookieString }) => {
      const { seoPage = {} } = state;
      const { src = "", dest = "", hardReloadFlag, cacheFor, carType = '' } = seoPage;
      const data = await fetchSeoCarSpecificRouteData(src, dest, carType, hardReloadFlag);
      const actions = [{
        type: UPDATE_UNIFICATION_FLOW,
        isUnificationFlow: 1
      }];
      if (data) {
        actions?.push({
          type: UPDATE_ROUTE_PAGE_DATA,
          results: data?.lob_data?.results,
          hideLob: data?.lob_data?.hideLob,
          voy_data: data?.voy_data,
          seo_meta: data?.seo_meta,
          top_routes_from_src: data?.routes?.top_routes_from_src,
          top_routes_from_src_title: data?.routes?.top_routes_from_src_title,
          top_routes_to_dest: data?.routes?.top_routes_to_dest,
          top_routes_to_dest_title: data?.routes?.top_routes_to_dest_title,
          rental_data: data?.routes?.rental_data,
          faq: data?.template?.faq,
          benefits: data?.template?.benefits,
          lpg: data?.template?.lpg,
          place_information: data?.template?.place_information,
          seo_content: data?.template?.seo_content,
          interlinking: data?.interlinking,
          dynamic_footer_data: data?.dynamic_footer_data,
          aggregate_ratings : data?.aggregate_ratings,
          schema_min_fare: data?.schema_min_fare,
          seo_multi_city: data?.seo_multi_city
        });
        actions.push({
          type: SHOW_SEO_LEADGEN,
          showSEOLeadgen: data?.showSEOLeadgen
        });
        actions.push({
          type: SHOW_INBOUND_CALL,
          showInboundCall: data?.showInboundCall         
        })
        actions.push({
          type: INBOUND_CONTACT_NUMBER,
          contactNumber:data?.contactNumber
        })
        if (data?.showSEOLeadgen && data?.query_fields && data?.query_fields?.length > 0) {
          actions.push({
            type: UPDATE_QUERY_FIELDS_DATA,
            queryFields: data.query_fields,
          });
        }
        if (data?.common_data?.source && data?.common_data?.destination) {
          const parseData = parseSeoParamsToConfig({
            source: data?.common_data?.source,
            destination: data?.common_data?.destination,
            tripType: "ONE_WAY",
            rf: "ow",
            cacheFor
          });
          actions.push({
            type: "UPDATE_RECENT_SEARCH",
            data: parseData,
          });
        }
        actions.push({
          type: SHOW_SEO_LEAVE_INTENT,
          showSEOLeaveIntent: data?.showSEOLeaveIntentForm
        })
        actions.push({
          type: SEO_FORM_COUPON_DATA,
          seoFormCouponData: data?.couponData
        })
      }

      return actions;
    },
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        const cacheFor = parseCacheConfig(searchString);
        const ttl = (cacheFor + 2)*86400; // Adding 2 -> Increase cache duration to 2 days for all pages
        const date = getCacheDate(cacheFor);
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        return { 
          cacheKey: `cabs_dweb_${params?.carType}_car_route_${params.src}_${params.dest}_${year}-${+month + 1}-${day}`,
          dynamicTTL: ttl
        };
      },
      aerospikeConfig: { ...aerospikeConfig },
    },
  },
  {
    path: "/cars/:carType-cabs-in-:src/",
    component: CityPage,
    key: "CarSpecificCityPage",
    toBeSSRed: true,
    fillStoreWaitTime: 7000,
    showHeader: true,
    showFooter: true,
    toBeCached: true,
    stickyHeader: true,
    populateStoreFromUrl: ({ params, searchString, baseUrl }, dispatch) => {
      const hardReloadFlag = parseHCBFlag(searchString);
      const cacheFor = parseCacheConfig(searchString);
      const flow = parseFlowName(searchString);
      dispatch({
        type: SEO_PAGE_NAME,
        seoPageName: seoCityCarTypeName,
      });
      dispatch({
        type: UPDATE_SRC_FROM_PARAMS,
        data: { src: params?.src, way: WAY_TYPE_IN, carType: params?.carType, hardReloadFlag, cacheFor },
      });
      dispatch({
        type: UPDATE_SEO_FLOW,
        isSeo: true
      });
      dispatch({
        type: SET_FLOW,
        flow: flow  || "seo",
      });
    },
    fillStoreOnServer: async ({ state, localData, cookieString }) => {
      const { seoPage = {} } = state;
      const { src = BLANK_VALUE, hardReloadFlag, cacheFor, carType = BLANK_VALUE } = seoPage;
      const data = await fetchSeoCarSpecificCityData(src, carType, WAY_TYPE_IN, hardReloadFlag);
      const actions = [{
        type: UPDATE_UNIFICATION_FLOW,
        isUnificationFlow: 1
      }];
      if (data) {
        actions?.push({
          type: UPDATE_CITY_PAGE_DATA,
          voy_data: data?.voy_data,
          seo_meta: data?.seo_meta,
          top_routes_from_src: data?.routes?.top_routes_from_src,
          top_routes_from_src_title: data?.routes?.top_routes_from_src_title,
          top_routes_to_dest: data?.routes?.top_routes_to_dest,
          top_routes_to_dest_title: data?.routes?.top_routes_to_dest_title,
          rental_data: data?.routes?.rental_data,
          faq: data?.template?.faq,
          benefits: data?.template?.benefits,
          lpg: data?.template?.lpg,
          place_information: data?.template?.place_information,
          seo_content: data?.template?.seo_content,
          interlinking: data?.interlinking,
          static_rental_data: data?.static_rental_data,
          static_table_data: data?.static_table_data,
          aggregate_ratings : data?.aggregate_ratings,
          schema_min_fare: data?.schema_min_fare,
          seo_multi_city: data?.seo_multi_city
        })
        actions.push({
          type: SHOW_SEO_LEADGEN,
          showSEOLeadgen: data?.showSEOLeadgen
        });
        actions.push({
          type: SHOW_INBOUND_CALL,
          showInboundCall: data?.showInboundCall         
        })
        actions.push({
          type: INBOUND_CONTACT_NUMBER,
          contactNumber:data?.contactNumber
        })
        if (data?.showSEOLeadgen && data?.query_fields && data?.query_fields?.length > 0) {
          actions.push({
            type: UPDATE_QUERY_FIELDS_DATA,
            queryFields: data.query_fields,
          });
        }
        if (data?.common_data?.source) {
          const parseData = parseSeoParamsToConfig({
            source: data?.common_data?.source,
            tripType: "ONE_WAY",
            rf: "ow",
            cacheFor
          });
          actions.push({
            type: "UPDATE_RECENT_SEARCH",
            data: parseData,
          });
        }
        if(carType){
          actions.push({
            type: UPDATE_CAR_TYPE,
            seoCarType: carType.charAt(0).toUpperCase() + carType?.slice(1)
          });
        }
        actions.push({
          type: SHOW_SEO_LEAVE_INTENT,
          showSEOLeaveIntent: data?.showSEOLeaveIntentForm
        })
        actions.push({
          type: SEO_FORM_COUPON_DATA,
          seoFormCouponData: data?.couponData
        })
      }

      return actions;
    },
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        const cacheFor = parseCacheConfig(searchString);
        const ttl = (cacheFor + 2)*86400; // Adding 2 -> Increase cache duration to 2 days for all pages
        const date = getCacheDate(cacheFor);
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        return { 
          cacheKey: `cabs_dweb_${params?.carType}_car_route_city_${params.src}_${year}-${+month + 1}-${day}`,
          dynamicTTL: ttl
        };
      },
      aerospikeConfig: { ...aerospikeConfig },
    },
  },
  {
    path: "/cars/ryde-cab-:src-to-:dest/",
    component: RoutePage,
    key: "RydeRoutePage",
    toBeSSRed: true,
    fillStoreWaitTime: 7000,
    showHeader: true,
    showFooter: true,
    toBeCached: true,
    stickyHeader: true,
    onServerInit: () => {
      setVerticalFooterData('cabs');
    },
    populateStoreFromUrl: ({ params, searchString, baseUrl }, dispatch) => {
      const hardReloadFlag = parseHCBFlag(searchString);
      const cacheFor = parseCacheConfig(searchString);
      const flow = parseFlowName(searchString);
      dispatch({
        type: SEO_PAGE_NAME,
        seoPageName: seoRouteRydePageName
      });
      dispatch({
        type: "UPDATE_SRC_DEST_FROM_PARAMS",
        data: { src: params?.src, dest: params?.dest, hardReloadFlag, cacheFor, carType: '' },
      });
      dispatch({
        type: UPDATE_SEO_FLOW,
        isSeo: true
      });
      dispatch({
        type: SET_FLOW,
        flow: flow  || "seo",
      });
    },
    fillStoreOnServer: async ({ state, localData, cookieString }) => {
      const { seoPage = {} } = state;
      const { src = "", dest = "", hardReloadFlag, cacheFor } = seoPage;
      const data = await fetchSeoRydeRouteData(src, dest, hardReloadFlag);
      const actions = [{
        type: UPDATE_UNIFICATION_FLOW,
        isUnificationFlow: 1
      }];
      if (data) {
        actions?.push({
          type: UPDATE_ROUTE_PAGE_DATA,
          results: data?.lob_data?.results,
          hideLob: data?.lob_data?.hideLob,
          voy_data: data?.voy_data,
          seo_meta: data?.seo_meta,
          top_routes_from_src: data?.routes?.top_routes_from_src,
          top_routes_from_src_title: data?.routes?.top_routes_from_src_title,
          top_routes_to_dest: data?.routes?.top_routes_to_dest,
          top_routes_to_dest_title: data?.routes?.top_routes_to_dest_title,
          rental_data: data?.routes?.rental_data,
          faq: data?.template?.faq,
          benefits: data?.template?.benefits,
          lpg: data?.template?.lpg,
          place_information: data?.template?.place_information,
          seo_content: data?.template?.seo_content,
          interlinking: data?.interlinking,
          dynamic_footer_data: data?.dynamic_footer_data,
          aggregate_ratings : data?.aggregate_ratings,
          schema_min_fare: data?.schema_min_fare,
          seo_multi_city: data?.seo_multi_city
        });
        if (data?.common_data?.source && data?.common_data?.destination) {
          const parseData = parseSeoParamsToConfig({
            source: data?.common_data?.source,
            destination: data?.common_data?.destination,
            tripType: "ONE_WAY",
            rf: "ow",
            cacheFor
          });
          actions.push({
            type: "UPDATE_RECENT_SEARCH",
            data: parseData,
          });
        }
        actions.push({
          type: SHOW_SEO_LEADGEN,
          showSEOLeadgen: data?.showSEOLeadgen
        });
        actions.push({
          type: SHOW_INBOUND_CALL,
          showInboundCall: data?.showInboundCall         
        })
        actions.push({
          type: INBOUND_CONTACT_NUMBER,
          contactNumber:data?.contactNumber
        })
        if (data?.showSEOLeadgen && data?.query_fields && data?.query_fields?.length > 0) {
          actions.push({
            type: UPDATE_QUERY_FIELDS_DATA,
            queryFields: data.query_fields,
          });
        }
        actions.push({
          type: SHOW_SEO_LEAVE_INTENT,
          showSEOLeaveIntent: data?.showSEOLeaveIntentForm
        })
        actions.push({
          type: SEO_FORM_COUPON_DATA,
          seoFormCouponData: data?.couponData
        })
      }

      return actions;
    },
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        const cacheFor = parseCacheConfig(searchString);
        const ttl = (cacheFor + 2)*86400; // Adding 2 -> Increase cache duration to 2 days for all pages
        const date = getCacheDate(cacheFor);
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        return { 
          cacheKey: `cabs_dweb_route_ryde_${params.src}_${params.dest}_${year}-${+month + 1}-${day}`,
          dynamicTTL: ttl
        };
      },
      aerospikeConfig: { ...aerospikeConfig },
    },
  },
  {
    path: "/cars/car-rental-in-:src/",
    component: RentalPage,
    key: RENTAL_PAGE,
    toBeSSRed: true,
    fillStoreWaitTime: 7000,
    showHeader: true,
    showFooter: true,
    toBeCached: true,
    stickyHeader: true,
    onServerInit: () => {
      setVerticalFooterData(CABS);
    },
    populateStoreFromUrl: ({ params, searchString, baseUrl }, dispatch) => {
      const hardReloadFlag = parseHCBFlag(searchString);
      const cacheFor = parseCacheConfig(searchString);
      const flow = parseFlowName(searchString);
      dispatch({
        type: SEO_PAGE_NAME,
        seoPageName: seoRentalPageName
      });
      dispatch({
        type: UPDATE_SRC_FROM_PARAMS,
        data: { src: params?.src, way: WAY_TYPE_IN, hardReloadFlag, cacheFor },
      });
      dispatch({
        type: UPDATE_PAGE_TYPE,
        data: { pageType: rental },
      });
      dispatch({
        type: UPDATE_SEO_FLOW,
        isSeo: true
      });
      dispatch({
        type: SET_FLOW,
        flow: flow  || "seo",
      });
    },
    fillStoreOnServer: async ({ state, localData, cookieString }) => {
      const { seoPage = {} } = state;
      const { src = BLANK_VALUE, dest = BLANK_VALUE, hardReloadFlag, cacheFor } = seoPage;
      const data = await fetchSeoRentalData(src, WAY_TYPE_IN, hardReloadFlag);
      const actions = [{
        type: UPDATE_UNIFICATION_FLOW,
        isUnificationFlow: 1
      }];
      if (data) {
        actions?.push({
          type: UPDATE_ROUTE_PAGE_DATA,
          results: data?.lob_data?.results,
          hideLob: data?.lob_data?.hideLob,
          voy_data: data?.voy_data,
          seo_meta: data?.seo_meta,
          top_routes_from_src: data?.routes?.top_routes_from_src,
          top_routes_from_src_title: data?.routes?.top_routes_from_src_title,
          top_routes_to_dest: data?.routes?.top_routes_to_dest,
          top_routes_to_dest_title: data?.routes?.top_routes_to_dest_title,
          rental_data: data?.routes?.rental_data,
          faq: data?.template?.faq,
          benefits: data?.template?.benefits,
          lpg: data?.template?.lpg,
          place_information: data?.template?.place_information,
          seo_content: data?.template?.seo_content,
          interlinking: data?.interlinking,
          package_carousel: data?.package_carousel,
          aggregate_ratings : data?.aggregate_ratings,
          schema_min_fare: data?.schema_min_fare,
          seo_multi_city: data?.seo_multi_city
        });
        if(data?.selectedPackageId && data?.package_carousel){
          actions.push({
            type: UPDATE_HR_PACKAGE,
            package_id: data?.selectedPackageId
          });
          actions.push({
            type: UPDATE_HR_PACKAGE_TIME,
            packageTime: data?.package_carousel[0]?.time
          });
          const responseData = {
            rentalPackages : data?.package_carousel || [], 
            selectedPackageId : data?.selectedPackageId || BLANK_VALUE
          };
          actions.push({
            type: HOURLY_RENTALS_DETAILS,
            hourlyRentalDetails: responseData || {}
          });
        }
        
        if (data?.common_data?.source) {
          const parseData = parseSeoParamsToConfig({
            source: data?.common_data?.source,
            destination: {},
            tripType: LOCAL_RENTAL,
            rf: HR,
            cacheFor,
            daysOffset: data?.days_offset
          });
          actions.push({
            type: UPDATE_RECENT_SEARCH,
            data: parseData,
          });
        }
        actions.push({
          type: SHOW_SEO_LEADGEN,
          showSEOLeadgen: data?.showSEOLeadgen
        });
        actions.push({
          type: SHOW_INBOUND_CALL,
          showInboundCall: data?.showInboundCall         
        })
        actions.push({
          type: INBOUND_CONTACT_NUMBER,
          contactNumber:data?.contactNumber
        })
        if (data?.showSEOLeadgen && data?.query_fields && data?.query_fields?.length > 0) {
          actions.push({
            type: UPDATE_QUERY_FIELDS_DATA,
            queryFields: data.query_fields,
          });
        }
        actions.push({
          type: SHOW_SEO_LEAVE_INTENT,
          showSEOLeaveIntent: data?.showSEOLeaveIntentForm
        })
        actions.push({
          type: SEO_FORM_COUPON_DATA,
          seoFormCouponData: data?.couponData
        })
      }

      return actions;
    },
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        const cacheFor = parseCacheConfig(searchString);
        const ttl = (cacheFor + 2)*86400; // Adding 2 -> Increase cache duration to 2 days for all pages
        const date = getCacheDate(cacheFor);
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        return { 
          cacheKey: `${CACHE_KEY?.rental}${params.src}_${params.dest}_${year}-${+month + 1}-${day}`,
          dynamicTTL: ttl
        };
      },
      aerospikeConfig: { ...aerospikeConfig },
    },
  },
  {
    path: "/cars/:src-to-:dest-cabs/",
    component: RoutePage,
    key: "RoutePage",
    toBeSSRed: true,
    fillStoreWaitTime: 7000,
    showHeader: true,
    showFooter: true,
    toBeCached: true,
    stickyHeader: true,
    onServerInit: () => {
      setVerticalFooterData('cabs');
    },
    populateStoreFromUrl: ({ params, searchString, baseUrl }, dispatch) => {
      const hardReloadFlag = parseHCBFlag(searchString);
      const cacheFor = parseCacheConfig(searchString);
      const flow = parseFlowName(searchString);
      dispatch({
        type: SEO_PAGE_NAME,
        seoPageName: seoRoutePageName
      });
      dispatch({
        type: "UPDATE_SRC_DEST_FROM_PARAMS",
        data: { src: params?.src, dest: params?.dest, hardReloadFlag, cacheFor, carType: '',pageType:'route' },
      });
      dispatch({
        type: UPDATE_SEO_FLOW,
        isSeo: true
      });
      dispatch({
        type: SET_FLOW,
        flow: flow || "seo_route",
      });
    },
    fillStoreOnServer: async ({ state, localData, cookieString }) => {
      const { seoPage = {} } = state;
      const { src = "", dest = "", hardReloadFlag, cacheFor } = seoPage;
      const data = await fetchSeoRouteData(src, dest, hardReloadFlag);
      const actions = [{
        type: UPDATE_UNIFICATION_FLOW,
        isUnificationFlow: 1
      }];
      if (data) {
        actions?.push({
          type: UPDATE_ROUTE_PAGE_DATA,
          results: data?.lob_data?.results,
          hideLob: data?.lob_data?.hideLob,
          voy_data: data?.voy_data,
          seo_meta: data?.seo_meta,
          top_routes_from_src: data?.routes?.top_routes_from_src,
          top_routes_from_src_title: data?.routes?.top_routes_from_src_title,
          top_routes_to_dest: data?.routes?.top_routes_to_dest,
          top_routes_to_dest_title: data?.routes?.top_routes_to_dest_title,
          rental_data: data?.routes?.rental_data,
          faq: data?.template?.faq,
          benefits: data?.template?.benefits,
          lpg: data?.template?.lpg,
          place_information: data?.template?.place_information,
          seo_content: data?.template?.seo_content,
          templatized_content: data?.template?.templatized_content,
          interlinking: data?.interlinking,
          dynamic_footer_data: data?.dynamic_footer_data,
          aggregate_ratings : data?.aggregate_ratings,
          schema_min_fare: data?.schema_min_fare,
          route_info: data?.routeInfo,
          seo_multi_city: data?.seo_multi_city
        });
        if (data?.common_data?.source && data?.common_data?.destination) {
          const parseData = parseSeoParamsToConfig({
            source: data?.common_data?.source,
            destination: data?.common_data?.destination,
            tripType: "ONE_WAY",
            rf: "ow",
            cacheFor,
            daysOffset: data?.days_offset
          });
          actions.push({
            type: "UPDATE_RECENT_SEARCH",
            data: parseData,
          });
        }
        actions.push({
          type: SHOW_SEO_LEADGEN,
          showSEOLeadgen: data?.showSEOLeadgen
        });
        actions.push({
          type: SHOW_INBOUND_CALL,
          showInboundCall: data?.showInboundCall         
        })
        actions.push({
          type: INBOUND_CONTACT_NUMBER,
          contactNumber:data?.contactNumber
        })
        if (data?.showSEOLeadgen && data?.query_fields && data?.query_fields?.length > 0) {
          actions.push({
            type: UPDATE_QUERY_FIELDS_DATA,
            queryFields: data.query_fields,
          });
        }
        actions.push({
          type: SHOW_SEO_LEAVE_INTENT,
          showSEOLeaveIntent: data?.showSEOLeaveIntentForm
        })
        actions.push({
          type: SEO_FORM_COUPON_DATA,
          seoFormCouponData: data?.couponData
        })
      }

      return actions;
    },
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        const cacheFor = parseCacheConfig(searchString);
        const ttl = (cacheFor + 2)*86400; // Adding 2 -> Increase cache duration to 2 days for all pages
        const date = getCacheDate(cacheFor);
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        return { 
          cacheKey: `cabs_dweb_route_${params.src}_${params.dest}_${year}-${+month + 1}-${day}`,
          dynamicTTL: ttl
        };
      },
      aerospikeConfig: { ...aerospikeConfig },
    },
  },
  {
    path: ["/cars/cabs-from-:src-airport/", "/cars/cab-from-:src-airport/"],
    component: AirportPage,
    key: "AirportPageSource",
    toBeSSRed: true,
    showHeader: true,
    showFooter: true,
    toBeCached: true,
    stickyHeader: true,
    fillStoreWaitTime: 7000,
    populateStoreFromUrl: ({ params, searchString, baseUrl }, dispatch) => {
      const hardReloadFlag = parseHCBFlag(searchString);
      const cacheFor = parseCacheConfig(searchString);
      const flow = parseFlowName(searchString);
      dispatch({
        type: SEO_PAGE_NAME,
        seoPageName: seoAirportCityPageName
      });
      dispatch({
        type: "UPDATE_SRC_FROM_PARAMS",
        data: { src: params?.src, way: "from", hardReloadFlag, cacheFor },
      });
      dispatch({
        type: UPDATE_SEO_FLOW,
        isSeo: true
      });
      dispatch({
        type: SET_FLOW,
        flow: flow  || "seo",
      });
    },
    fillStoreOnServer: async ({ state, localData, cookieString }) => {
      const { seoPage = {} } = state;
      const { src = "", hardReloadFlag, cacheFor } = seoPage;
      const data = await fetchSeoAirportCityData(src, "from", hardReloadFlag);
      const actions = [{
        type: UPDATE_UNIFICATION_FLOW,
        isUnificationFlow: 1
      }];
      if (data) {
        actions?.push({
          type: UPDATE_ROUTE_PAGE_DATA,
          results: data?.lob_data?.results,
          hideLob: data?.lob_data?.hideLob,
          voy_data: data?.voy_data,
          seo_meta: data?.seo_meta,
          top_routes_from_src: data?.routes?.top_routes_from_src,
          top_routes_from_src_title: data?.routes?.top_routes_from_src_title,
          top_routes_to_dest: data?.routes?.top_routes_to_dest,
          top_routes_to_dest_title: data?.routes?.top_routes_to_dest_title,
          rental_data: data?.routes?.rental_data,
          faq: data?.template?.faq,
          benefits: data?.template?.benefits,
          lpg: data?.template?.lpg,
          place_information: data?.template?.place_information,
          seo_content: data?.template?.seo_content,
          interlinking: data?.interlinking,
          aggregate_ratings : data?.aggregate_ratings,
          schema_min_fare: data?.schema_min_fare,
          seo_multi_city: data?.seo_multi_city
        });
        actions.push({
          type: SHOW_SEO_LEADGEN,
          showSEOLeadgen: data?.showSEOLeadgen
        });
        actions.push({
          type: SHOW_INBOUND_CALL,
          showInboundCall: data?.showInboundCall         
        })
        actions.push({
          type: INBOUND_CONTACT_NUMBER,
          contactNumber:data?.contactNumber
        })
        if (data?.showSEOLeadgen && data?.query_fields && data?.query_fields?.length > 0) {
          actions.push({
            type: UPDATE_QUERY_FIELDS_DATA,
            queryFields: data.query_fields,
          });
        }
        if (data?.common_data?.source) {
          const parseData = parseSeoParamsToConfig({
            source: data?.common_data?.source,
            destination: data?.common_data?.destination,
            tripType: "AIRPORT",
            rf: "at",
            cacheFor
          });
          actions.push({
            type: "UPDATE_RECENT_SEARCH",
            data: parseData,
          });
        }
        actions.push({
          type: SHOW_SEO_LEAVE_INTENT,
          showSEOLeaveIntent: data?.showSEOLeaveIntentForm
        })
        actions.push({
          type: SEO_FORM_COUPON_DATA,
          seoFormCouponData: data?.couponData
        })
      }

      return actions;
    },
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        const cacheFor = parseCacheConfig(searchString);
        const ttl = (cacheFor + 2)*86400; // Adding 2 -> Increase cache duration to 2 days for all pages
        const date = getCacheDate(cacheFor);
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        return {
          cacheKey: `cabs_dweb_airport_cabs_from_${params?.src}_${year}-${+month + 1}-${day}`,
          dynamicTTL: ttl
        };
      },
      aerospikeConfig: { ...aerospikeConfig },
    },
  },
  {
    path: ["/cars/cabs-to-:dest-airport/", "/cars/cab-to-:dest-airport/"],
    component: AirportPage,
    key: "AirportPageDestination",
    toBeSSRed: true,
    showHeader: true,
    showFooter: true,
    toBeCached: true,
    stickyHeader: true,
    fillStoreWaitTime: 7000,
    populateStoreFromUrl: ({ params, searchString, baseUrl }, dispatch) => {
      const hardReloadFlag = parseHCBFlag(searchString);
      const cacheFor = parseCacheConfig(searchString);
      const flow = parseFlowName(searchString);
      dispatch({
        type: SEO_PAGE_NAME,
        seoPageName: seoAirportCityPageName
      });
      dispatch({
        type: "UPDATE_DEST_FROM_PARAMS",
        data: { dest: params?.dest, way: "to", hardReloadFlag, cacheFor },
      });
      dispatch({
        type: UPDATE_SEO_FLOW,
        isSeo: true
      });
      dispatch({
        type: SET_FLOW,
        flow: flow  || "seo",
      });
    },
    fillStoreOnServer: async ({ state, localData, cookieString }) => {
      const { seoPage = {} } = state;
      const { dest = "", hardReloadFlag, cacheFor } = seoPage;
      const data = await fetchSeoAirportCityData(dest, "to", hardReloadFlag);
      const actions = [{
        type: UPDATE_UNIFICATION_FLOW,
        isUnificationFlow: 1
      }];
      if (data) {
        actions?.push({
          type: UPDATE_ROUTE_PAGE_DATA,
          voy_data: data?.voy_data,
          seo_meta: data?.seo_meta,
          results: data?.lob_data?.results,
          hideLob: data?.lob_data?.hideLob,
          top_routes_from_src: data?.routes?.top_routes_from_src,
          top_routes_from_src_title: data?.routes?.top_routes_from_src_title,
          top_routes_to_dest: data?.routes?.top_routes_to_dest,
          top_routes_to_dest_title: data?.routes?.top_routes_to_dest_title,
          rental_data: data?.routes?.rental_data,
          faq: data?.template?.faq,
          benefits: data?.template?.benefits,
          lpg: data?.template?.lpg,
          place_information: data?.template?.place_information,
          seo_content: data?.template?.seo_content,
          interlinking: data?.interlinking,
          aggregate_ratings : data?.aggregate_ratings,
          schema_min_fare: data?.schema_min_fare,
          seo_multi_city: data?.seo_multi_city
        });
        actions.push({
          type: SHOW_SEO_LEADGEN,
          showSEOLeadgen: data?.showSEOLeadgen
        });
        actions.push({
          type: SHOW_INBOUND_CALL,
          showInboundCall: data?.showInboundCall         
        })
        actions.push({
          type: INBOUND_CONTACT_NUMBER,
          contactNumber:data?.contactNumber
        })
        if (data?.showSEOLeadgen && data?.query_fields && data?.query_fields?.length > 0) {
          actions.push({
            type: UPDATE_QUERY_FIELDS_DATA,
            queryFields: data.query_fields,
          });
        }
        if (data?.common_data?.destination) {
          const parseData = parseSeoParamsToConfig({
            source: data?.common_data?.source,
            destination: data?.common_data?.destination,
            tripType: "AIRPORT",
            rf: "at",
            cacheFor
          });
          actions.push({
            type: "UPDATE_RECENT_SEARCH",
            data: parseData,
          });
        }
        actions.push({
          type: SHOW_SEO_LEAVE_INTENT,
          showSEOLeaveIntent: data?.showSEOLeaveIntentForm
        })
        actions.push({
          type: SEO_FORM_COUPON_DATA,
          seoFormCouponData: data?.couponData
        })
      }

      return actions;
    },
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        const cacheFor = parseCacheConfig(searchString);
        const ttl = (cacheFor + 2)*86400; // Adding 2 -> Increase cache duration to 2 days for all pages
        const date = getCacheDate(cacheFor);
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        return {
          cacheKey: `cabs_dweb_airport_cabs_to_${params?.dest}_${year}-${+month + 1}-${day}`,
          dynamicTTL: ttl
        };
      },
      aerospikeConfig: { ...aerospikeConfig },
    },
  },
  {
    path: ["/cars/cabs-from-:src/", "/cars/cab-from-:src/"],
    component: CityPage,
    key: "CityPageSource",
    toBeSSRed: true,
    showHeader: true,
    showFooter: true,
    toBeCached: true,
    stickyHeader: true,
    fillStoreWaitTime: 7000,
    populateStoreFromUrl: ({ params, searchString, baseUrl }, dispatch) => {
      const hardReloadFlag = parseHCBFlag(searchString);
      const cacheFor = parseCacheConfig(searchString);
      const flow = parseFlowName(searchString);
      dispatch({
        type: SEO_PAGE_NAME,
        seoPageName: seoCityPageName
      });
      dispatch({
        type: "UPDATE_SRC_FROM_PARAMS",
        data: { src: params?.src, way: "from", hardReloadFlag, cacheFor },
      });
      dispatch({
        type: UPDATE_SEO_FLOW,
        isSeo: true
      });
      dispatch({
        type: SET_FLOW,
        flow: flow  || "seo",
      });
    },
    fillStoreOnServer: async ({ state, localData, cookieString }) => {
      const { seoPage = {} } = state;
      const { src = "", hardReloadFlag, cacheFor } = seoPage;
      const data = await fetchSeoCityData(src, "from", hardReloadFlag);
      const actions = [{
        type: UPDATE_UNIFICATION_FLOW,
        isUnificationFlow: 1
      }];
      if (data) {
        actions?.push({
          type: UPDATE_CITY_PAGE_DATA,
          voy_data: data?.voy_data,
          seo_meta: data?.seo_meta,
          top_routes_from_src: data?.routes?.top_routes_from_src,
          top_routes_from_src_title: data?.routes?.top_routes_from_src_title,
          top_routes_to_dest: data?.routes?.top_routes_to_dest,
          top_routes_to_dest_title: data?.routes?.top_routes_to_dest_title,
          rental_data: data?.routes?.rental_data,
          faq: data?.template?.faq,
          benefits: data?.template?.benefits,
          lpg: data?.template?.lpg,
          place_information: data?.template?.place_information,
          seo_content: data?.template?.seo_content,
          interlinking: data?.interlinking,
          static_rental_data: data?.static_rental_data,
          static_table_data: data?.static_table_data,
          static_rental_table_data: data?.static_rental_table_data,
          dynamic_footer_data: data?.dynamic_footer_data,
          aggregate_ratings : data?.aggregate_ratings,
          schema_min_fare: data?.schema_min_fare,
          seo_multi_city: data?.seo_multi_city
        });
        actions.push({
          type: SHOW_SEO_LEADGEN,
          showSEOLeadgen: data?.showSEOLeadgen
        });
        actions.push({
          type: SHOW_INBOUND_CALL,
          showInboundCall: data?.showInboundCall         
        })
        actions.push({
          type: INBOUND_CONTACT_NUMBER,
          contactNumber:data?.contactNumber
        })
        actions.push({
          type: SHOW_SEO_LEAVE_INTENT,
          showSEOLeaveIntent: data?.showSEOLeaveIntentForm
        })
        actions.push({
          type: SEO_FORM_COUPON_DATA,
          seoFormCouponData: data?.couponData
        })
        if (data?.showSEOLeadgen && data?.query_fields && data?.query_fields?.length > 0) {
          actions.push({
            type: UPDATE_QUERY_FIELDS_DATA,
            queryFields: data.query_fields,
          });
        }
        if (data?.common_data?.source) {
          const parseData = parseSeoParamsToConfig({
            source: data?.common_data?.source,
            destination: data?.common_data?.destination,
            tripType: "ONE_WAY",
            rf: "ow",
            cacheFor
          });
          actions.push({
            type: "UPDATE_RECENT_SEARCH",
            data: parseData,
          });
        }

        if (data?.selectedPackageId) {
          actions.push({
            type: UPDATE_HR_PACKAGE,
            package_id: data?.selectedPackageId
          });
        }

        if (data?.selectedPackageTime) {
          actions.push({
            type: UPDATE_HR_PACKAGE_TIME,
            packageTime: data?.package_carousel[0]?.time
          });
        }
        
      }

      return actions;
    },
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        const cacheFor = parseCacheConfig(searchString);
        const ttl = (cacheFor + 2)*86400; // Adding 2 -> Increase cache duration to 2 days for all pages
        const date = getCacheDate(cacheFor);
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        return {
          cacheKey: `cabs_dweb_city_cabs_from_${params?.src}_${year}-${+month + 1}-${day}`,
          dynamicTTL: ttl
        };
      },
      aerospikeConfig: { ...aerospikeConfig },
    },
  },
  {
    path: ["/cars/cabs-to-:dest/", "/cars/cab-to-:dest/"],
    component: CityPage,
    key: "CityPageDestination",
    toBeSSRed: true,
    showHeader: true,
    showFooter: true,
    toBeCached: true,
    stickyHeader: true,
    fillStoreWaitTime: 7000,
    populateStoreFromUrl: ({ params, searchString, baseUrl }, dispatch) => {
      const hardReloadFlag = parseHCBFlag(searchString);
      const cacheFor = parseCacheConfig(searchString);
      const flow = parseFlowName(searchString);
      dispatch({
        type: SEO_PAGE_NAME,
        seoPageName: seoCityPageName
      });
      dispatch({
        type: "UPDATE_DEST_FROM_PARAMS",
        data: { dest: params?.dest, way: "to", hardReloadFlag, cacheFor },
      });
      dispatch({
        type: UPDATE_SEO_FLOW,
        isSeo: true
      });
      dispatch({
        type: SET_FLOW,
        flow: flow  || "seo",
      });
    },
    fillStoreOnServer: async ({ state, localData, cookieString }) => {
      const { seoPage = {} } = state;
      const { dest = "", hardReloadFlag, cacheFor } = seoPage;
      const data = await fetchSeoCityData(dest, "to", hardReloadFlag);
      const actions = [{
        type: UPDATE_UNIFICATION_FLOW,
        isUnificationFlow: 1
      }];
      if (data) {
        actions?.push({
          type: UPDATE_CITY_PAGE_DATA,
          voy_data: data?.voy_data,
          seo_meta: data?.seo_meta,
          top_routes_from_src: data?.routes?.top_routes_from_src,
          top_routes_from_src_title: data?.routes?.top_routes_from_src_title,
          top_routes_to_dest: data?.routes?.top_routes_to_dest,
          top_routes_to_dest_title: data?.routes?.top_routes_to_dest_title,
          rental_data: data?.routes?.rental_data,
          faq: data?.template?.faq,
          benefits: data?.template?.benefits,
          lpg: data?.template?.lpg,
          place_information: data?.template?.place_information,
          seo_content: data?.template?.seo_content,
          interlinking: data?.interlinking,
          static_rental_data: data?.static_rental_data,
          static_table_data: data?.static_table_data,
          static_rental_table_data: data?.static_rental_table_data,
          dynamic_footer_data: data?.dynamic_footer_data,
          aggregate_ratings : data?.aggregate_ratings,
          schema_min_fare: data?.schema_min_fare,
          seo_multi_city: data?.seo_multi_city
        });
        actions.push({
          type: SHOW_SEO_LEADGEN,
          showSEOLeadgen: data?.showSEOLeadgen
        });
        actions.push({
          type: SHOW_INBOUND_CALL,
          showInboundCall: data?.showInboundCall         
        })
        actions.push({
          type: INBOUND_CONTACT_NUMBER,
          contactNumber:data?.contactNumber
        })
        if (data?.showSEOLeadgen && data?.query_fields && data?.query_fields?.length > 0) {
          actions.push({
            type: UPDATE_QUERY_FIELDS_DATA,
            queryFields: data.query_fields,
          });
        }
        if (data?.common_data?.destination) {
          const parseData = parseSeoParamsToConfig({
            source: data?.common_data?.source,
            destination: data?.common_data?.destination,
            tripType: "ONE_WAY",
            rf: "ow",
            cacheFor
          });
          actions.push({
            type: "UPDATE_RECENT_SEARCH",
            data: parseData,
          });
        }
        
        if (data?.selectedPackageId) {
          actions.push({
            type: UPDATE_HR_PACKAGE,
            package_id: data?.selectedPackageId
          });
        }

        if (data?.selectedPackageTime) {
          actions.push({
            type: UPDATE_HR_PACKAGE_TIME,
            packageTime: data?.package_carousel[0]?.time
          });
        }
        actions.push({
          type: SHOW_SEO_LEAVE_INTENT,
          showSEOLeaveIntent: data?.showSEOLeaveIntentForm
        })
        actions.push({
          type: SEO_FORM_COUPON_DATA,
          seoFormCouponData: data?.couponData
        })
      }

      return actions;
    },
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        const cacheFor = parseCacheConfig(searchString);
        const ttl = (cacheFor + 2)*86400; // Adding 2 -> Increase cache duration to 2 days for all pages
        const date = getCacheDate(cacheFor);
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        return {
          cacheKey: `cabs_dweb_city_cabs_to_${params?.dest}_${year}-${+month + 1}-${day}`,
          dynamicTTL: ttl
        };
      },
      aerospikeConfig: { ...aerospikeConfig },
    },
  },
  {
    path: ["/:partner/results/", "/:partner/review/"],
    component: SearchPage,
    key: "srp",
    showHeader: true,
    showFooter: true,
    stickyHeader: true,
    fillStoreWaitTime: 2000,
    // other options
    // toBeSSRed = true | false,
    // toBeCached = true | false,
    // isModal = true | false,
    // directLanding = true | false,
    // cacheConfig = {},
    // fillStoreOnServer = () => {},
    populateStoreFromUrl: async ({ params, searchString, baseUrl }, dispatch) => {
      const parseData = await parseResultsPageUrlToConfig(searchString);
      
      const { filters, sem_flow = false,utm_medium = '',utm_campaign = '',showQueryCB=false,source={},destination={},startDate={}, package_id = '', stopOvers = [] } = parseData;
      dispatch({
        type: "UPDATE_RECENT_SEARCH",
        data: parseData,
      });
      // added package_id for HR
      if (package_id) {
        dispatch({
          type: UPDATE_HR_PACKAGE,
          package_id: package_id
        });
      }
      if (filters) {
        dispatch({
          type: "UPDATE_FILTERS",
          filters,
        });
      }
      if (sem_flow) {
        dispatch({
          type: 'SET_SEM_FLOW',
          sem_flow,
          utm_medium,
          utm_campaign
        })
        dispatch({
          type:'SHOW_QUERY_CB',
          showQueryCB
        })
        dispatch({
          type:'UPDATE_SRC_DEST_DATE',
          src : source?.name || '',
          dest :destination?.name || '',
          startDate:startDate?.date || ''
        })
      }

      if (stopOvers?.length) {
        dispatch({
          type:UPDATE_MULTICITY_STOPOVERS,
          stopOvers
        })
        dispatch({
          type: UPDATE_PREVIOUS_MULTICITY_STOPOVERS,
          previousStopOvers: stopOvers
        })
      }
    },
    fillStoreOnServer: async ({ state, cookieString, searchString }) => {
      const parseData = await parseResultsPageUrlToConfig(searchString);
      const { source={},destination={},startDate={}, endDate={}, tripType={}, package_id = '', stopOvers = [], flow = '', isSeo = false } = parseData;
      const config_data = await fetchCabConfigData()
      let actions = [{
        type: UPDATE_UNIFICATION_FLOW,
        isUnificationFlow: 1
      }]
      let redirectUrl = createUnificationRedirectUrl({
        source,
        destination,
        startDate,
        endDate,
        rf: tripType?.rf,
        package_id,
        stopOvers,
        flow,
        isSeo: !!isSeo,
      })
      if (config_data) {
        actions.push({
          type: UPDATE_CABS_CONFIG_DATA,
          configData: config_data
        })
      }
      return { actions, redirectUrl, status: 301 };
    }
    // actionsBeforeRenderOnServer = () => {},
  },
  {
    path: "/:partner/confirm/",
    component: ReviewPage,
    key: "review",
    showHeader: true,
    showFooter: true,
    stickyHeader: true,
    fillStoreWaitTime: 2000,
    // other options
    // toBeSSRed = true | false,
    // toBeCached = true | false,
    // isModal = true | false,
    // directLanding = true | false,
    // cacheConfig = {},
    populateStoreFromUrl: ({ params, searchString, baseUrl }, dispatch) => {
      const parseData = parseReviewPageUrlToConfig(searchString);
      const {
        dispatchSearchId,
        key,
        vehicle_type,
        source,
        destination,
        startDate,
        endDate,
        tripType,
        isSeo,
        flow,
        pc,
        is_ryde, 
        package_id,
        packageTime,
        stopOvers
      } = parseData;

      // added package_id for HR
      if (package_id && package_id?.length) {
        dispatch({
          type: UPDATE_HR_PACKAGE,
          package_id: package_id
        });
      }
      // added packageTime to show on review page for HR
      if (packageTime && packageTime.toString()?.length) {
        dispatch({
          type: UPDATE_HR_PACKAGE_TIME,
          packageTime: packageTime
        });
      }
      dispatch({
        type: UPDATE_SELECTED_CAB,
        selectedCab: { dispatchSearchId, key, vehicle_type, pc,is_ryde },
      });
      dispatch({
        type: "UPDATE_TRIP_TYPE",
        tripType: tripType
      })

      if (stopOvers?.length) { 
        dispatch({
          type:UPDATE_MULTICITY_STOPOVERS,
          stopOvers
        })
        dispatch({
          type: UPDATE_PREVIOUS_MULTICITY_STOPOVERS,
          previousStopOvers: stopOvers
        })
      }
      if (isSeo) {
        dispatch({
          type: "UPDATE_RECENT_SEARCH",
          data: {
            source,
            destination,
            startDate,
            endDate,
            tripType,
            isSeo,
            flow,
            pc,
          },
        });
      } else if (flow) {
        dispatch({
          type: 'SET_FLOW',
          flow
        });
      }
    },
    fillStoreOnServer: async ({ cookieString, searchString }) => {
      const parseData = await parseCarsReviewUrl(searchString);
      const { source={},destination={},startDate={}, endDate={}, tripType={}, package_id = '', stopOvers = [], flow = '', isSeo = false, category_id = '' } = parseData;

      const config_data = await fetchCabConfigData()

      let actions = [{
        type: UPDATE_UNIFICATION_FLOW,
        isUnificationFlow: 1
      }]
      let redirectUrl = '';
      if (category_id) {
        redirectUrl = createUnificationRedirectUrl({
          source,
          destination,
          startDate,
          endDate,
          rf: tripType?.rf,
          package_id,
          stopOvers,
          flow,
          isSeo,
          isReview: true,
          category_id
        })
      }
      if (config_data) {
        actions.push({
          type: UPDATE_CABS_CONFIG_DATA,
          configData: config_data
        })
      }
      return { actions, redirectUrl, status: redirectUrl?.length ? 301 : 200 }; 
    }
  },
  {
    path: "/:partner/airport-cabs/",
    component: HomePage,
    key: "airportHome",
    showHeader: true,
    showFooter: true,
    stickyHeader: true,
    fillStoreWaitTime: 2000,
    populateStoreFromUrl: ({ params, searchString, baseUrl }, dispatch) => {
      const parseData = parseHomePageUrlToConfig(searchString);
      parseData['tripType'] = {
        name: 'AIRPORT',
        rf: 'at'
      };
      const metaData = getMetaData();
      parseData.metaData = metaData;
      dispatch({
        type: "UPDATE_RECENT_SEARCH",
        data: parseData,
      });
    },
    onServerInit: () => {
      setMetaData();
    },
    fillStoreOnServer: async ({ cookieString }) => {
        const pageMakerData = await fetchPageMakerAPIServer({ isTemplates: "cabs_dweb_home_data" });
        const faqData = await fetchPageMakerAPIServer({ isTemplates: "cabs_faq_data" });
        const config_data = await fetchCabConfigData()
        let actions = [{
          type: UPDATE_UNIFICATION_FLOW,
          isUnificationFlow: 1
        }]
        if (config_data) {
          actions.push({
            type: UPDATE_CABS_CONFIG_DATA,
            configData: config_data
          })
        }
        if (faqData && pageMakerData) {
          const newAction = [
            {
              type: UPDATE_CAB_FAQ_DATA,
              faqData: faqData?.cabs_faq_data
            },
            {
              type: 'UPDATE_PAGEMAKER_RESPONSE',
              pageMakerResponse: pageMakerData
            }
          ]
  
          actions = [...actions, ...newAction]
        } else if (faqData && !pageMakerData) {
          const newAction = [{
            type: UPDATE_CAB_FAQ_DATA,
            faqData: faqData?.cabs_faq_data
          }]
  
          actions = [...actions, ...newAction]
        } else if (pageMakerData && !faqData) {
          const newAction = [{
            type: 'UPDATE_PAGEMAKER_RESPONSE',
            pageMakerResponse: pageMakerData
          }]
  
          actions = [...actions, ...newAction]
        }
  
        return actions;
    }
  },
  {
    path: "/:partner/rental-cabs/",
    component: HomePage,
    key: "rentalHome",
    showHeader: true,
    showFooter: true,
    stickyHeader: true,
    fillStoreWaitTime: 2000,
    populateStoreFromUrl: ({ params, searchString, baseUrl }, dispatch) => {
      const parseData = parseHomePageUrlToConfig(searchString);
      parseData['tripType'] = {
        name: 'LOCAL_RENTAL',
        rf: 'hr'
      };
      const metaData = getMetaData();
      parseData.metaData = metaData;
      dispatch({
        type: "UPDATE_RECENT_SEARCH",
        data: parseData,
      });
    },
    onServerInit: () => {
      setMetaData();
    },
    fillStoreOnServer: async ({ cookieString }) => {
      const pageMakerData = await fetchPageMakerAPIServer({ isTemplates: "cabs_dweb_home_data" });
      const faqData = await fetchPageMakerAPIServer({ isTemplates: "cabs_faq_data" });
      const config_data = await fetchCabConfigData()
      let actions = [{
        type: UPDATE_UNIFICATION_FLOW,
        isUnificationFlow: 1
      }]
      if (config_data) {
        actions.push({
          type: UPDATE_CABS_CONFIG_DATA,
          configData: config_data
        })
      }
      if (faqData && pageMakerData) {
        const newAction = [
          {
            type: UPDATE_CAB_FAQ_DATA,
            faqData: faqData?.cabs_faq_data
          },
          {
            type: 'UPDATE_PAGEMAKER_RESPONSE',
            pageMakerResponse: pageMakerData
          }
        ]

        actions = [...actions, ...newAction]
      } else if (faqData && !pageMakerData) {
        const newAction = [{
          type: UPDATE_CAB_FAQ_DATA,
          faqData: faqData?.cabs_faq_data
        }]

        actions = [...actions, ...newAction]
      } else if (pageMakerData && !faqData) {
        const newAction = [{
          type: 'UPDATE_PAGEMAKER_RESPONSE',
          pageMakerResponse: pageMakerData
        }]

        actions = [...actions, ...newAction]
      }

      return actions;
    }
  },
  {
    path: "/:partner/one-way-cab/",
    component: HomePage,
    fillStoreWaitTime:7000,
    key: "oneWayHome",
    showHeader: true,
    showFooter: true,
    stickyHeader: true,
    populateStoreFromUrl: ({ params, searchString, baseUrl }, dispatch) => {
      dispatch({
        type: SET_ONEWAY_CAB,
        isOneWayCab: true,
      });
      const parseData = parseHomePageUrlToConfig(searchString);
      const metaData = getMetaData();
      parseData.metaData = metaData;
      dispatch({
        type: "UPDATE_RECENT_SEARCH",
        data: parseData,
      });
    },
    onServerInit: () => {
      setMetaData();
    },
    fillStoreOnServer: async ({ cookieString }) => {
      const pageMakerData = await fetchPageMakerAPIServer({ isTemplates: "cabs_dweb_home_data" });
      const data = await fetchOneWayCabInterlinkingData();
      const faqData = await fetchPageMakerAPIServer({ isTemplates: "cabs_faq_data" });
      const config_data = await fetchCabConfigData()
      const actions = [{
        type: UPDATE_UNIFICATION_FLOW,
        isUnificationFlow: 1
      }];

      if (config_data) {
        actions.push({
          type: UPDATE_CABS_CONFIG_DATA,
          configData: config_data
        })
      }

      if (faqData && pageMakerData) {
        actions.push({
          type: UPDATE_CAB_FAQ_DATA,
          faqData: faqData?.cabs_faq_data
        },
        {
          type: 'UPDATE_PAGEMAKER_RESPONSE',
          pageMakerResponse: pageMakerData
        })
      }

      if (faqData && !pageMakerData) {
        actions.push({
          type: UPDATE_CAB_FAQ_DATA,
          faqData: faqData?.cabs_faq_data
        })
      }

      if (pageMakerData && !faqData) {
        actions.push({
          type: 'UPDATE_PAGEMAKER_RESPONSE',
          pageMakerResponse: pageMakerData
        })
      }
      actions?.push({
        type: ONEWAY_INTERLINKING_DATA,
        oneWayInterlinks: data
      })
      return actions;
    }
  },
  {
    path: "/:partner/faq/",
    component: FaqPage,
    key: "faq",
    showHeader: true,
    showFooter: true,
    stickyHeader: true,
    fillStoreOnServer: async () => {
      const faqData = await fetchPageMakerAPIServer({ isTemplates: "cabs_faq_data" });
      const actions = [];
      if (faqData) {
        actions.push({
          type: UPDATE_CAB_FAQ_DATA,
          faqData: faqData?.cabs_faq_data
        });
      }
      return actions;
    }
  },
  {
    path: "/:partner/provisionalHOB/",
    component: HobLandingPage,
    key: "hob",
    showHeader: false,
    showFooter: false,
    stickyHeader: false,
    fillStoreWaitTime: 5000,
    populateStoreFromUrl: ({ params, searchString, baseUrl }, dispatch) => {
      const parseData = parseHobUrlToConfig(searchString, baseUrl);
      dispatch({
        type: UPDATE_HOB_LANDING_PARAMS,
        data: parseData
      });
    },
    fillStoreOnServer: async ({state, localData}) => {
      const { hob = {} } = state;
      const request = {
        flight_id: hob?.flightBookingId,
        source_param: hob?.source,
        is_departure: hob?.isDeparture,
        type : PROVISIONAL_HOB_REQUEST_TYPE
      }

      const actions = []
      const response = await getPageLoadHOBData(request, hob?.orgId);
      const provisionalResponse = response?.response?.[0] || null
      if (provisionalResponse && Object.keys(provisionalResponse)?.length) {
        actions.push({
          type: UPDATE_HOB_LANDING_RESPONSE,
          data: {
            provisionalResponse: provisionalResponse,
            source_message: provisionalResponse?.source_message,
            airport_city_code: provisionalResponse?.airport_city_code,
            terminal: provisionalResponse?.terminal,
            pickupTime: provisionalResponse?.default_pickup_time
          }
        })
      } 
      return actions
    }
  },
  {
    path: "/:partner/listingHOB/",
    component: HobListingPage,
    key: "listingHob",
    showHeader: false,
    showFooter: false,
    stickyHeader: false,
    populateStoreFromUrl: ({ params, searchString, baseUrl }, dispatch) => {
      const parseData = parseHobUrlToConfig(searchString, baseUrl);
      dispatch({
        type: UPDATE_HOB_LISTING_PARAMS,
        data: parseData
      });
    },
    fillStoreOnServer: async () => {}
  },
  {
    path: "/:partner/thankyouHOB/",
    component: HobThankYouPage,
    key: "thankyouHob",
    showHeader: false,
    showFooter: false,
    stickyHeader: false,
    populateStoreFromUrl: ({ params, searchString, baseUrl }, dispatch) => {
      const parseData = parseHobUrlToConfig(searchString, baseUrl);
      dispatch({
        type: UPDATE_HOB_THANKYOU_PARAMS,
        data: parseData
      });
    },
    fillStoreOnServer: async () => {}
  },
  {
    path: ["/cars/multicity-:src-to-:dest-cabs/", "/cars/char-dham-yatra-cabs/"],
    component: CharDhamPage,
    key: "charDham",
    toBeSSRed: true,
    fillStoreWaitTime: 7000,
    showHeader: true,
    showFooter: true,
    toBeCached: true,
    stickyHeader: true,
    onServerInit: () => {
      setVerticalFooterData('cabs');
    },
    populateStoreFromUrl: ({ params, searchString, baseUrl }, dispatch) => {
      const hardReloadFlag = parseHCBFlag(searchString);
      const cacheFor = parseCacheConfig(searchString);
      const flow = parseFlowName(searchString);
      dispatch({
        type: SEO_PAGE_NAME,
        seoPageName: seoCharDhamPageName
      });
      dispatch({
        type: "UPDATE_SRC_DEST_FROM_PARAMS",
        data: { src: params?.src, dest: params?.dest, hardReloadFlag, cacheFor, carType: '',pageType:'char_dham' },
      });
      dispatch({
        type: UPDATE_SEO_FLOW,
        isSeo: true
      });
      dispatch({
        type: SET_FLOW,
        flow: flow  || "seo",
      });
    },
    fillStoreOnServer: async ({state, cookieString}) => {
      const { seoPage = {} } = state;
      const { cacheFor } = seoPage;
      const data = await fetchCharDhamRouteData();
      const actions = [{
        type: UPDATE_UNIFICATION_FLOW,
        isUnificationFlow: 1
      }];
      if (data) {
        actions?.push({
          type: "UPDATE_CHAR_DHAM_DATA",
          data: data
        });
        actions.push({
          type: UPDATE_SOURCE,
          source: data?.sourceData
        })
        actions.push({
          type: UPDATE_DESTINATION, 
          destination: data?.destinationData
        })
        if (data?.sourceData && data?.destinationData) {
          const parseData = parseSeoParamsToConfig({
            source: data?.sourceData,
            destination: data?.destinationData,
            tripType: "ONE_WAY",
            rf: "ow",
            cacheFor,
            daysOffset:1,
          });
          actions.push({
            type: "UPDATE_RECENT_SEARCH",
            data: parseData,
          });
        }
      }
      return actions;
    },
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        const cacheFor = parseCacheConfig(searchString);
        const ttl = (cacheFor + 2)*86400; // Adding 2 -> Increase cache duration to 2 days
        const date = getCacheDate(cacheFor);
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        return { 
          cacheKey: `cabs_dweb_char_dham_static_${year}-${+month + 1}-${day}`,
          dynamicTTL: ttl
        };
      },
      aerospikeConfig: { ...aerospikeConfig },
    },
  },
  {
    path: "/cars/",
    component: HomePage,
    key: "home",
    showHeader: true,
    showFooter: true,
    stickyHeader: true,
    toBeSSRed: true,
    toBeCached: true,
    fillStoreWaitTime: 2000,
    populateStoreFromUrl: ({ params, searchString, baseUrl }, dispatch) => {
      logger?.info?.({
        type: "cars-home-route",
        message: `[/cars/] populateStoreFromUrl searchString=${searchString || "(empty)"}`,
      });
      if (typeof window !== "undefined") {
        console.log("[/cars/] populateStoreFromUrl (client)", { searchString, baseUrl, params });
      }
      const parseData = parseHomePageUrlToConfig(searchString);
      const flow = parseFlowName(searchString);
      const metaData = getMetaData();
      parseData.metaData = metaData;
      dispatch({
        type: "UPDATE_RECENT_SEARCH",
        data: parseData,
      });
      dispatch({
        type: SET_FLOW,
        flow,
      });
      logger?.info?.({
        type: "cars-home-route",
        message: `[/cars/] populateStoreFromUrl done flow=${flow}`,
      });
    },
    onServerInit: () => {
      logger?.info?.({
        type: "cars-home-route",
        message: "[/cars/] onServerInit - setMetaData()",
      });
      setMetaData();
    },
    fillStoreOnServer: async ({ cookieString, searchString }) => {
      logger?.info?.({
        type: "cars-home-route",
        message: `[/cars/] fillStoreOnServer start searchString=${searchString || "(empty)"}`,
      });
      // const parseData = await parseResultsPageUrlToConfig(searchString);
      // const { flow = 'other-channel' } = parseData;
      // const redirectUrl = createUnificationRedirectLandingUrl({ tripType: "OW", flow: flow || 'other-channel' });
      // return { actions: [], redirectUrl: redirectUrl, status: 301 };

      const pageMakerData = await fetchPageMakerAPIServer({ isTemplates: "cabs_dweb_home_data" });
      logger?.info?.({
        type: "cars-home-route",
        message: `[/cars/] fetchPageMakerAPIServer(cabs_dweb_home_data) ${pageMakerData ? "OK" : "EMPTY"}`,
      });
      const faqData = await fetchPageMakerAPIServer({ isTemplates: "cabs_faq_data" });
      logger?.info?.({
        type: "cars-home-route",
        message: `[/cars/] fetchPageMakerAPIServer(cabs_faq_data) ${faqData ? "OK" : "EMPTY"}`,
      });
      const config_data = await fetchCabConfigData()
      logger?.info?.({
        type: "cars-home-route",
        message: `[/cars/] fetchCabConfigData ${config_data ? "OK" : "EMPTY/FAILED"}`,
      });
      let actions = [{
        type: UPDATE_UNIFICATION_FLOW,
        isUnificationFlow: 1
      }]
      if (config_data) {
        actions.push({
          type: UPDATE_CABS_CONFIG_DATA,
          configData: config_data
        })
      }
      if (faqData && pageMakerData) {
        const newAction = [
          {
            type: UPDATE_CAB_FAQ_DATA,
            faqData: faqData?.cabs_faq_data
          },
          {
            type: 'UPDATE_PAGEMAKER_RESPONSE',
            pageMakerResponse: pageMakerData
          }
        ]

        actions = [...actions, ...newAction]
      } else if (faqData && !pageMakerData) {
        const newAction = [{
          type: UPDATE_CAB_FAQ_DATA,
          faqData: faqData?.cabs_faq_data
        }]

        actions = [...actions, ...newAction]
      } else if (pageMakerData && !faqData) {
        const newAction = [{
          type: 'UPDATE_PAGEMAKER_RESPONSE',
          pageMakerResponse: pageMakerData
        }]

        actions = [...actions, ...newAction]
      }

      logger?.info?.({
        type: "cars-home-route",
        message: `[/cars/] fillStoreOnServer returning ${actions.length} actions`,
      });
      return actions;
    },
    cacheConfig: {
      getCacheKey: ({ params, searchString }) => {
        const cacheFor = parseCacheConfig(searchString);
        const ttl = (cacheFor + 2) * 86400; // +2 days buffer, same as other SEO routes
        const date = getCacheDate(cacheFor);
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        return {
          cacheKey: `cabs_dweb_home_page_${year}-${+month + 1}-${day}`,
          dynamicTTL: ttl,
        };
      },
      aerospikeConfig: { ...aerospikeConfig },
    },
  }
];

export default GoibiboRoutes;